import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export const isProd = publicRuntimeConfig.NODE_ENV === 'production'
export const isRunningSpecs = () => {
  if (typeof window !== 'undefined') {
    return (
      !!(window as any).Cypress || navigator?.userAgent.toLowerCase().indexOf(' electron/') > -1
    )
  } else {
    return false
  }
}

export const ExperimentIds = {
  browserPay: isProd ? 'IaIzXvlNQN6zDwbfzClCQg' : 'ohZEMxJ3Q9KU35pojirknQ',
}
